import mobileic from "@Images/mobile-ic.png";
import "@Styles/mandate.css";
// import { getAnalytics, logEvent } from "firebase/analytics";
import { initializeApp } from "firebase/app";
import React, { useEffect, useState } from "react";
import "react-confirm-alert/src/react-confirm-alert.css";
import Modal from "react-modal";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Form } from "semantic-ui-react";
import alert from "../../../../../src/Images/NewUI/alert.png";
import ToastMsg from "../../../.././helper/ToastMsg";
import { withRouter } from "../../../../hooks/withRouter";
import trustimg from "../../../../Images/NewUI/trustlock.png";
import { notifyVisitorEvent } from "../../../../Redux/ApplyLoan/action";
import {
  checkForOrderId,
  createOrderCard,
  fetchUTMLogo,
  phoneNumberVerify,
  refreshToken,
  saveManualToken,
  savePhoneNumber,
  signInUser,
} from "../../../../Redux/Authenticate/action";
import { getUserDetail } from "../../../../Redux/GeneralDetails/action";
import { getDocumentStatus } from "../../../../Redux/Manual_Kyc_Details/action";
import { recordEvent } from "../../../../utils/appFlyer";
import { decodeAuthToken } from "../../../../utils/authToken";
import { Loader } from "../../Common/Loader";
import VerifyMobileNumber from "../../User/NewUser/VerifyOtp";

// const firebaseConfig = {
//   apiKey: "AIzaSyD9sTeEaubYm8LeJlfRo_EMrb43WFzeJk4",
//   authDomain: "payme-india.firebaseapp.com",
//   databaseURL: "https://payme-india.firebaseio.com",
//   projectId: "payme-india",
//   storageBucket: "payme-india.appspot.com",
//   messagingSenderId: "435990090197",
//   appId: "1:435990090197:web:bdc0a2ca31304e83ff6d5c",
//   measurementId: "G-HDEGFJGY0E",
// };

// const firebase_initials = initializeApp(firebaseConfig);
// const analytics = getAnalytics(firebase_initials);
const logoUrl = process.env.REACT_APP_MMB_LOGO;
const mainUrl = process.env.REACT_APP_MMB_MAINIMG;


const options = {
  position: "top-center",
  autoClose: 2000,
  limit: 1,
  closeButton: false,
};

const optInput = {
  display: "inline",
  float: "left",
  width: "100%",
  padding: "24px 0px",
  // marginRight: 10,
  backgroundColor: "#FFFFFF",
  border: "none",
  borderRadius: 15,
  outline: "none",
  fontWeight: 600,
  textAlign: "center",
  redirect_url: "",
  font: "Roboto",
};

const NewSignIn = (props) => {
  const navigate = useNavigate();

  const [isLargeScreen, setIsLargeScreen] = useState(window.innerWidth > 440);
  const refferal_code = new URLSearchParams(window.location.search).get( "referrer");
  const clickid = new URLSearchParams(window.location.search).get("clickid");
  const is_deeplink = new URLSearchParams(window.location.search).get("is_deeplink");
  const isOpenFrom = new URLSearchParams(window.location.search).get("open_from");
  const partnerId = new URLSearchParams(window.location.search).get("partner_id");
  const authTc = new URLSearchParams(window.location.search).get("auth_tc");
  const [showOtpModal, setShowOtpModal] = useState(false);


if (clickid) {
  localStorage.setItem("clickid", clickid);
}
if (partnerId) {
  localStorage.setItem("partner_id", partnerId);
}
if (isOpenFrom == "app"){
  localStorage.setItem("isOpenFrom","true")
}
if(is_deeplink=='True'){
  localStorage.setItem("is_deeplink",true)
}
else{
  if(localStorage.getItem('is_deeplink')){
    localStorage.removeItem('is_deeplink');
  }
 
}

  const token = localStorage.getItem("gpay_token");

  const [receivedKey, setReceivedKey] = useState("");
  const [webPerp , setWebPerp] = useState("")



  useEffect(() => {
    const handleResize = () => {
      setIsLargeScreen(window.innerWidth > 440);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    recordEvent({ eventName: "registration_page",
                 eventParams: { Platform: "web" },
                  });
    const source = new URLSearchParams(window.location.search).get("utm_source") || document.referrer || "";
    const campaign = new URLSearchParams(window.location.search).get("utm_campaign") || "";
    const partner_id = new URLSearchParams(window.location.search).get("partner_id") || "";
    nv("event", "registration_page", {
      source: source,
      campaign: campaign,
      partner_id: partner_id,
    }, "100", 1);

  }, []);

  const redirectUrl = (url) => {
    window.open(url, "_blank");
  };

  useEffect(() => {
    handleQueryParam();
    
    const storedPhoneNumber = localStorage.getItem('phonenumber');
    if (storedPhoneNumber) {
      setmobileNumber(storedPhoneNumber);
      setState({ is_enable: true });
    }
  }, []);
  
  const handleQueryParam = () => {
    const searchParams = new URLSearchParams(location.search);
  
    const webPerp = searchParams.get("webPerp") || "";
    const receivedKey = searchParams.get("isLanding") || "";
    const openFrom = searchParams.get("open_from") || "";
    const phoneNumberParam = searchParams.get("phone_number") || "";
    setWebPerp(webPerp);
    setReceivedKey(receivedKey);
    localStorage.setItem("webPerp", webPerp);
    localStorage.setItem("receivedKey", receivedKey);
    if (openFrom === "app") {
      localStorage.setItem("register_from", "android");
    } else {
      localStorage.removeItem("register_from");
    }

    localStorage.setItem("isFromPlJourney", receivedKey);

    if (phoneNumberParam && /^[6-9]\d{9}$/.test(phoneNumberParam)) {
      setmobileNumber(phoneNumberParam);
      setState({ is_enable: true });
    }
  };
  

  localStorage.setItem("referrer", refferal_code);
  useEffect(() => {
    if (authTc) {

      const decodedToken = decodeAuthToken(authTc);
     
      if (decodedToken) {
        localStorage.setItem("gpay_token", decodedToken);
        props.saveManualToken(decodedToken);
        window.location.href = `/dashboard_s`;
        return;
      }
    }
  }, [authTc]);

  useEffect(() => {
    if (localStorage.getItem("gpay_token") && !authTc) {
      if (localStorage.getItem("isFromPlJourney")) {
        if (localStorage.getItem("cibilfalsenblocked")) {
          window.location.href = `/dashboard_s`;
        } else {
          if (localStorage.getItem("iscibilform")==="true"){
            window.location.href = `/creditlimit`;
          }
          else
          window.location.href = `/completeprofilenew`;
        }
      } else {
        window.location.href = `/dashboard_s`;
      }
    }
  
    
    localStorage.setItem("utm_medium", new URLSearchParams(window.location.search).get("utm_campaign"))
    localStorage.setItem("utm_source", new URLSearchParams(window.location.search).get("utm_source"))
    localStorage.setItem("utm_campaign", new URLSearchParams(window.location.search).get("utm_campaign"))

   
    if (localStorage.getItem("gpay_token")) {
      navigate("/dashboard_s");
    }
  }, []);
  const [phone_number, setmobileNumber] = useState("");
  const [checked, setChecked] = useState(true);
  const [maxOtpError, setMaxOtpError] = useState("");
  const [modalState, setModalState] = useState(false);
  const [showProceedPopUp, setShowProceedPopup] = useState(false);
  const [logo, setLogo] = useState(null);
const [error, setError] = useState(null);

useEffect(() => {
  handleUTMLogo();
}, []);


const handleUTMLogo = () => {
  
  const urlParams = new URLSearchParams(window.location.search);
  const refer_code = urlParams.get('referrer'); 
  // const refer_code =  "8Y0TELG6"

  if (refer_code) {
    setLoader(true);
    props.fetchUTMLogo(refer_code)
      .then((res) => {
        setLoader(false);
        console.log('Logo fetched successfully:', res.logo);
        setLogo(res.logo); 
      })
      .catch((err) => {
        console.error('Error fetching UTM logo:', err);
        setError(err); 
        if (err.response?.status === 401) {
          window.location.href = '/';
          localStorage.removeItem('gpay_token');
        }
        let errorMessage = err?.response?.data?.error;
        ToastMsg(errorMessage, 'error');
      });
  } else {
    console.log('No referrer found in the URL.');
  }
};
  
  
  const [state, setState] = useState({
    referCode: "",
    is_enable: false,
    isChecked: false,
    loading: false,
  });
  const [enterMPIN, setMPIN] = useState("");
  const [is_user_new, setIsUserNew] = useState(true);
  const [loader, setLoader] = useState(false);
  const mobileNoRegex = /^[0-9\b]+$/;
  const mpinChange = (event) => {
    setMPIN(event);

    if (event.length === 6) {
      setState({ is_enable: true });
    } else {
      setState({ is_enable: false });
    }
  };
  // const setPhone = (e) => {
  //   e.preventDefault();
  //   const { name, value } = e.target;
  //   let arr = ["6", "7", "8", "9"];
  //   if (value === "" || mobileNoRegex.test(value)) {
  //     if (arr.includes(value[0]) || value === "" || value[1]) {
  //       if (value[0] === "0") {
  //         setmobileNumber(value.slice(1, 11));
  //         if (value.length >= 10) {      
  //         }
  //       } else {
  //         setmobileNumber(value.slice(0, 10));
  //         if (value.length >= 10) {
  //         }
  //       }
  //     }
  //     if (value.length === 10 && value[0] !== "0") {
  //       setState({ is_enable: true });
  //     } else {
  //       setState({ is_enable: false });
  //     }
  //   }
  // };



  const setPhone = (e) => {
    e.preventDefault();
    const { name, value } = e.target;
    let arr = ["6", "7", "8", "9"];
    
    if (value === "" || mobileNoRegex.test(value)) {
      if (arr.includes(value[0]) || value === "" || value[1]) {
        if (value[0] === "0") {
          setmobileNumber(value.slice(1, 11));
          if (value.length >= 10) {
            localStorage.setItem('phonenumber', value.slice(1, 11)); 
          }
        } else {
          setmobileNumber(value.slice(0, 10));
          if (value.length >= 10) {
            localStorage.setItem('phonenumber', value.slice(0, 10)); 
          }
        }
      }
      if (value.length === 10 && value[0] !== "0") {
        setState({ is_enable: true });
      } else {
        setState({ is_enable: false });
      }
    }
  };

  const notify = (err) => {
    toast.error(err, { ...options });
  };

  const hanldePhoneNumberVerify = (e) => {
    setLoader(true);
    localStorage.setItem("phone_number", phone_number);
    e.preventDefault();
  
    props
      .phoneNumberVerify({ phone_number })
      .then((res) => {
        setState({ loading: false });
        setLoader(false);
  
        if (res.phone_number_verified === false) {
          // 🔥 Show OTP popup instead of redirect
          setShowOtpModal(true);
        } else if (res.phone_number_verified === true) {
          localStorage.setItem("in_new_user", false);
          setIsUserNew(false);
        }
      })
      .catch((err) => {
        setLoader(false);
        if (err.response?.status === 401) {
          window.location.href = "/";
          localStorage.removeItem("gpay_token");
        }
        let error = err?.response?.data?.error;
        setMaxOtpError(error);
        setShowProceedPopup(true);
      });
  };
  

  const submitMpin = () => {
    let mpin = parseInt(enterMPIN);
    let data = {
      // phone_number,
      // mpin,
    };
    props
      .signInUser(data)
      .then((res) => {
        nv("event", "LoginResult", { Login: true }, "100", 1);
        if (res.status === 200) {
          let token = res.data && res.data.data.token;
          props.saveManualToken(token);
          props.savePhoneNumber({ phone_number: phone_number });

          props
            .getUserDetail(token)
            .then((res) => {
              let nv_data = res?.data?.data?.customusermodel;
              localStorage.setItem("userID", res?.data?.data?.id)
              let user_data_nv = {
                mobile: nv_data?.phone_number,
                email: res?.data?.data?.email,
                name: nv_data?.first_name + " " + nv_data?.last_name,
                registrationStartDate: res.data.data.created_at,
                "preferred language": "en",
              };

              let user_data = {
                mobile: `91${nv_data.phone_number}`,
                gender: nv_data?.gender,
                birth_date: nv_data?.date_of_birth,
                "preferred language": "en",
                registrationStartDate: res.data.data.created_at,
                email: res?.data?.data?.email,
                name: nv_data?.first_name + " " + nv_data?.last_name,
              };

              let result_nv = nv_data?.gender ? user_data : user_data_nv;

              nv("user", res?.data?.data?.id, result_nv);
            })
            .catch((err) => { 
              setLoader(false);
              if (err.response?.status === 401) {
                window.location.href = "/";
                localStorage.removeItem("gpay_token");
              }
              let error = err?.response?.data?.error;
              ToastMsg(error, "error");
              // console.log(err);
            });

          props
            .getDocumentStatus(token)
            .then((res) => {
              res.data.map((details) => {
                if (details.cibil_form) {
                  if (details.karza) {
                    navigate("/karza");
                  } else {
                    navigate("/creditlimit");
                  }
                } 
                  else {
                    // props.history.push("/dashboard_s");
                  }

              });
            })
            .catch((err) => {
              setLoader(false);
              if (err.response?.status === 401) {
                window.location.href = "/";
                localStorage.removeItem("gpay_token");
              }
              let error = err?.response?.data?.error;
              ToastMsg(error, "error");
              // console.log(err);
            });
        } else {
          ToastMsg(res?.data?.error, "error");
        }
      })
      .catch((err) => {
        setLoader(false);
        if (err.response?.status === 401) {
          window.location.href = "/";
          localStorage.removeItem("gpay_token");
        }
        let error = err?.response?.data?.error;
        ToastMsg(error, "error");
        // console.log(err);
      });
  };

  const redirectToForgot = () => {
    let mob = state.mobileNumber;
    localStorage.setItem("isForgot", true);
    navigate("/forget-mpin", { state: { mobile: mob } });
  };
  const handleRedirect = () => {
    window.open('https://www.paymeindia.in/terms/', '_blank', 'noopener,noreferrer');
  };

  const handleprivacypolicyredirect = () => {
    window.open('https://www.paymeindia.in/privacy-policy/', '_blank', 'noopener,noreferrer');
  };

  console.log(maxOtpError, "maxOtpError");
  
  return (

    <>

<VerifyMobileNumber
  {...props}                       
  isOpen={showOtpModal}
  onRequestClose={() => {
    setShowOtpModal(false);
    window.location.reload();   
  }}
  phone_number={phone_number}
/>

    <Modal
      isOpen={showProceedPopUp}
      className="proceed-popup justifycontentrepay"
      onRequestClose={() => setShowProceedPopup(false)} 
      >
        <img src={alert} width={76} alt="failed" />
        <h3 className="mt-40">Max OTP Attempts Reached</h3>
        <span className="otppopuptext">{maxOtpError}</span>
        <div onClick={() => setShowProceedPopup(false)} className="otpmodalbtn">Okay</div>
       
        {/* <div> <p>Powered by RBI regulated Account Aggregator: </p> <img src={loanFailed} width={65} alt="finvu-con" />  </div> */}
        {/* <div className="btn-wrapper"> <button onClick={handleproceedClick} >Proceed</button></div> */}
      </Modal>
      
      <div id="dashboardbackground" className="main_div">
        {loader ? <Loader /> : null}

       <div className="UpperImgdiv">
      

      {/* {isLargeScreen ? (
        <img
          src={Astroimglarge}
          className="AstroImage"
          alt="PaymeIndia"
        />
      ):
      (<img
        src={Astroimg}
        className="AstroImage"
        alt="PaymeIndia"
      />)} */}
    </div>
        <div  className="container-sm margintopfix newsignin">



        <div className="logo-container">
  {logo ? (
    <>
      {/* <img width={120} src={logo} alt="UTM Logo" className="utm-logo" /> */}
      <div className="vertical-line"></div> 
      <div className="autodebitfix">
      <img width={236} src={mainUrl} alt="PayMe Logo" className="payme-logo mb-47" />
      <img width={158} src={logoUrl} alt="PayMe Logo" className="payme-logo" /></div>
    </>
  ) : (
    <div className="autodebitfix">
    <img width={236} src={mainUrl} alt="PayMe Logo" className="centered-payme-logo mb-47" />
    <img width={158} src={logoUrl} alt="PayMe Logo" className="centered-payme-logo" /></div>
  )}
</div>

{console.log(mainUrl, "logourl")}






          <div className="pb-4">

            <div  className="wrapper-content">
              <div className="text-center mx-auto ">
                <div style={{marginBottom:"120px"}} className=" d-flex  flex-column justify-content-between">
                  <div className="pt-3 "></div>
                  <Form className="mt-20" style={{ textAlign: "centre" }}>
                    
                    <span
                      className="main__page font-size-18"
                      name="otp"
                      // style={{ paddingLeft: "6px" }}
                    >
                      Sign In With 
                    </span>
                    <br />
                    <br />
                    <div
                      className="mobile_number_i flex align-center"
                    >
                      <Form.Field>
                        {/* <img
                          className="phoneicon"
                          src={mobileic}
                          alt="mobileicon"
                          style={{ margin: "0 0 0 0" }}
                        /> */}
                        {/* <input
                          placeholder="Login Via Mobile Number"
                          className="inputStyleHero"
                          type="text"
                          data-testid="input_phonnenumber"
                          maxLength={10}
                          value={phone_number}
                          name="phone_number"
                          onChange={setPhone}
                          style={{marginLeft:"0 !important"}}
                        /> */}
                         <div className="input-wrapper newsigninhover">
                          <img
                          className="phoneicon"
                          src={mobileic}
                          alt="mobileicon"
                          style={{ margin: "0 0 0 0" }}
                        />
             <input
                className="input mb-20"
                type="text"
                data-testid="input_phonnenumber"
                maxLength={10}
                value={phone_number}
                name="phone_number"
                onChange={setPhone}
                onKeyDown={(e) => {
                  if (e.key === "Enter" && state.is_enable && checked) {
                    is_user_new ? hanldePhoneNumberVerify(e) : submitMpin(e);
                  }
                }}
                style={{ marginLeft: "0 !important" }}
                placeholder=" "
              />
              <label style={{marginLeft: 20, fontSize: "15px"}} className="label">Mobile Number</label>
            </div>
                      </Form.Field>
                    </div>
                    <span className="aadharHerodiv mt-20">Please enter your {" "} <span  className="mmb-gradient font16600 ">AADHAAR</span> {" "} linked mobile number</span>

                   <div className="flex-row-new mt-20">
                   <div  onClick={()=>{setChecked(!checked)}} className="main-check2 "
                      // style={{marginTop:"15px !important"}}
                      >
                        <input
                          type="checkbox"
                          name="agree"
                          id="mycheckbox"
                          className="checkbox"
                          checked={checked}
                        />
                        <span className="geekmark"></span>
                        
                      </div>
                      <p className="checkText">
                      By clicking, I agree to the <span  className="homepageconcent"> <span className="mmb-gradient" onClick={() => redirectUrl(process.env.REACT_APP_T_C)}>Terms and conditions ,</span> <span className="mmb-gradient" onClick={() => redirectUrl(process.env.REACT_APP_PRIVACY_POLICY)}>Privacy Policy</span> </span> 
                      </p>
                      
                   </div>
                   
         


                    {/* <Form.Field
                    className={`pt-5 mb-3 ${
                      !is_user_new ? "" : "display_none"
                    }`}
                    disabled={is_user_new}
                  >
                    <label className="main__page font-size-18" name="otp">
                      Enter MPIN
                    </label>
                    <div>
                      <OtpInput
                        name="enterMPIN"
                        value={enterMPIN}
                        onChange={mpinChange}
                        numInputs={6}
                        isInputNum={true}
                        separator={<span></span>}
                        inputStyle={optInput}
                      />
                    </div>
                  </Form.Field> */}
                  </Form>
                  
                </div>
                
            
              </div>
              
            </div>
        

          </div>

         
         

     
        <div className="text-center marginfix-lse stickeybottomsign">
            <div className="bg--white-mmb">
            {state.is_enable && checked?
            <button
            onClick={is_user_new ? hanldePhoneNumberVerify : submitMpin}
            className=" bg-orange text-white newbtnDesignsign font700 py-6 "
          >
            Get OTP
          </button>:
          <button
          className=" bg-orange text-white newbtnDesignsign blur font700 py-6 "
        >
          Get OTP
        </button>
            }
            </div>
            
            <div className="trusted-box">
  <img 
    src={trustimg}  
    alt="shield"
    className="trusted-icon"
  />
  <span className="trusted-text">
    <span className="tenmplus">10M+</span> Happy Customers
  </span>
</div>
          </div>
        </div>
  
      </div>
    
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.user,
  };
};
export default withRouter(connect(mapStateToProps, {
  getDocumentStatus,
  signInUser,
  createOrderCard,
  checkForOrderId,
  savePhoneNumber,
  saveManualToken,
  fetchUTMLogo,
  phoneNumberVerify,
  notifyVisitorEvent,
  getUserDetail,
  refreshToken,
})(NewSignIn));